import SvgIcon from '@/components/common/svg-icon.vue'; // svg component
import { install } from '@/i18n';
import { initReport, rem, request, vueTap, user } from '@tencent/ppd-base-libs';
import { setRequest } from '@tencent/wphk-act-base-cgi';
import { setServerTime } from '@tencent/wphk-components-common/utils/server-time';
import VueCompositionAPI from '@vue/composition-api';
import { axios } from '@tencent/wphk-base-request';
import { createPinia, PiniaVuePlugin } from 'pinia';
import smoothscroll from 'smoothscroll-polyfill';
import Vue from 'vue';
import Router from 'vue-router';
import App from './App.vue';
import routerInfo from './router';
import { getServerTime } from './utils/date-helper';
// 上报
import mtaGlobalConfig from '@/mta-config-global';
import { plugin } from '@tencent/fit-bi-sdk';
import { setUpWeixin } from './utils/setup-wx';
import { initLoginInterceptors } from './utils/handle-login';
import Aegis from 'aegis-web-sdk';

// kick off the polyfill!
smoothscroll.polyfill();
// 设置系统时间
const win: any = window;
const serverTime = win.__$$_serverTimeMills ? new Date(win.__$$_serverTimeMills) : new Date();
setServerTime(serverTime.getTime());
console.log('读取时间getServerTime：', getServerTime());

// register globally
Vue.component('SvgIcon', SvgIcon);

const req = require.context('@/assets/icons/svg', false, /\.svg$/); // params：文件夹，是否使用子文件夹，文件匹配正则

req.keys().map((ele) => req(ele));

const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);

const isProduction = process.env.VUE_APP_ENV === 'production';
if (isProduction) {
  // 接入aegis上报
  const aegis = new Aegis({
    id: '16qJPSlvLKzqv8z2Wj', // 上报 id
    uin: user.getUin(), // 用户唯一 ID（可选）
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    hostUrl: 'https://rumt-zh.com',
    pvUrl: '',  // 去除pv上报
    whiteListUrl: '',
  });
  Vue.config.errorHandler = function (err, vm, info) {
    aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
  };
}

// 注册组合式API和pinia
Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.use(install);
// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);


Vue.use(plugin, {
  // 用到mtaGlobalConf里的cid/sid/group/project/projectDesc属性
  ...mtaGlobalConfig,
  route: router,
});
// 处理登陆失效
initLoginInterceptors();
request.init(axios);
setRequest(request);
initReport(
  {
    router,
    // @ts-ignore
    appEnv: process.env.VUE_APP_ENV,
    // @ts-ignore
    business: process.env.VUE_APP_PKGNAME, // 区分业务，用于elk
    isReportPageStayedTime: true, // 是否上报页面停留时间
    sentry: {
      dsn: 'https://c05e48ef096e447b8b601663d1e542d0@report.url.cn/sentry/3929',
      // webpack变异全局变量
      release: process.env.VUE_APP_SENTRY_VERSION,
    },
    bi: {
      reportNeedLogin: true,
    },
  },
  Vue,
);

// 微信sdk初始化
setUpWeixin();

// 开启rem布局
rem();
// 开启vtap
Vue.use(vueTap);

Vue.config.productionTip = false;

// vue 忽略报错 wx-open-subscribe
Vue.config.ignoredElements = ['wx-open-subscribe', 'wx-open-launch-weapp'];

new Vue({
  pinia,
  router,
  render: (h) => h(App),
}).$mount('#app');
